var a={"@@functional/placeholder":!0};export{a as default};
//# sourceMappingURL=__.js.map
